import React, { createContext, useContext } from "react";

export const RADSelectionContext = createContext();

export const RADSelectionProvider = ({ value, children }) => (
  <RADSelectionContext.Provider value={value}>
    {children}
  </RADSelectionContext.Provider>
);

export const useRADSelection = () => {
  const context = useContext(RADSelectionContext);
  if (!context) {
    throw new Error(
      "useRADSelection must be used within a RADSelectionProvider"
    );
  }
  return context;
};
